import { memo } from "react";
import { ListItem } from "../common/Listitem";

import './FooterLinkButton.scss';

export interface FooterLinkButtonProps {
    label: string;
    onClick: () => void;
}

export const FooterLinkButton = memo(({ onClick, label }: FooterLinkButtonProps) => (
    <ListItem>
        <button className="footer__link-button" 
            dangerouslySetInnerHTML={{ __html: label }}
            onClick={onClick}
            type="button" />
    </ListItem>
));
